import PdfVisualizer from './PdfVisualizer';

export default PdfVisualizer;
